interface starsHoverScope extends ng.IScope {
  benchmark: string;
  popoverContent: string;
}

interface JQuery {
  popover: any;
}

export default function StarsHoverDirective() {
  return {
    restrict: 'A',
    link: function (scope: starsHoverScope, element, attrs) {
      // Get benchmark percentage
      scope.benchmark = attrs.benchmark + '%';

      // Build popover content for Bootstrap popover
      scope.popoverContent =
        '' +
        '<div class="popover-benchmark">' +
        scope.benchmark +
        '</div>' +
        '<div class="popover-high"></div><div class="popover-low"></div>' +
        '<div class="popover-scale popover-scale-label1">100</div>' +
        '<div class="popover-scale popover-scale-label2">50</div>' +
        '<div class="popover-scale popover-scale-label3">0</div>';

      // Configure Bootstrap popover handler
      ($(element) as any).popover({
        trigger: 'hover',
        html: true,
        title: 'benchmark',
        content: scope.popoverContent,
        container: 'body',
        delay: { show: 10, hide: 100 },
        placement: 'right',
        template: `<div class="popover benchmark-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>`
      });
    }
  };
}
